BaseLayer = require './base-layer'

module.exports = App.TileLayerComponent = BaseLayer.extend
  url: 'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png'
  leafletRequiredOptions: [ 'url' ]
  leafletOptions: [
    'minZoom'
    'maxZoom'
    'maxNativeZoom'
    'tileSize'
    'subDomains'
    'errorTileUrl'
    'attribution'
    'tms'
    'continuousWorld'
    'noWrap'
    'zoomOffset'
    'zoomReverse'
    'opacity'
    'zIndex'
    'unloadInvisibleTiles'
    'updateWhenIdle'
    'detectRetina'
    'reuseTiles'
    'bounds'
  ]
  leafletEvents: [
    'loading'
    'load'
    'tileloadstart'
    'tileload'
    'tileunload'
  ]
  leafletProperties: [
    'url'
    'zIndex'
    'opacity'
  ]
  createLayer: ->
    @L.tileLayer.apply @L, @get('requiredOptions').concat([ @get('options') ])